"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavLink = void 0;
var React = __importStar(require("react"));
var DozukiHeader_1 = require("../../DozukiHeader");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var colors_1 = require("../../colors");
var NavLink = function (_a) {
    var className = _a.className, children = _a.children, linkProps = __rest(_a, ["className", "children"]);
    var LinkComponent = (0, useHeaderProps_1.useHeaderProps)().LinkComponent;
    var highlightStyle = {
        bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR,
    };
    var baseStyle = {
        p: 2,
        fontSize: 'md',
        display: 'flex',
        alignItems: 'center',
        h: DozukiHeader_1.NAV_HEIGHT,
        color: colors_1.DEFAULT_TEXT_COLOR,
        textDecoration: 'none',
    };
    return (React.createElement(LinkComponent, __assign({ className: className, position: "relative" }, baseStyle, linkProps, { _hover: highlightStyle }), children));
};
exports.NavLink = NavLink;
